export function getKeys(Enunm: object, value: string | number) {
  return Object.entries(Enunm).find(([key, val]) => val === value)?.[0];
}
